import React from 'react';
import { FaRegCheckCircle } from 'react-icons/fa';

const WaitlistSuccess = () => {
  return (
    <div className="bg-gray-100 min-h-screen flex items-center justify-center">
      <div className="bg-white p-8 flex flex-col items-center rounded-md shadow-md w-[90%] max-w-md md:w-full lg:w-full" >
        <FaRegCheckCircle className='text-green-900 text-6xl' />
        <h1 className="text-3xl font-semibold mb-6">Thank You!</h1>
        <p className="text-gray-700 mb-4">
          Thank you for joining our waitlist. We'll notify you as soon as the product becomes available.
        </p>
       
    
      </div>
    </div>
  );
};

export default WaitlistSuccess;